// taken from React canUseDom
export const RenderingOnClient = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

export const RenderingOnServer = !RenderingOnClient;
